module.exports = __webpack_public_path__ + "static/media/osa.23ac3899.svg";